<template>
  <div v-if="relatedTab">

    <!-- <template slot="header">
        <h3>{{ relatedTab.name }}</h3>
      </template> -->

    <quick-create-modal :title="$displayLabel(modalTitleData, 'module_name')" :openModal="modalComputed" @onClose="onModalClose" :formData="formData"
    @onSave="onModalSave($event)" :disabledFields="disabledFields" :action="modalAction" :rowHash="modalRowHash" :delegatorUrl="delegatorUrl" :moduleHash="relatedTab.moduleHash" :parentRowHash="parentRowHash" />

    <div class="vx-row" v-if="relatedModulePermissions.canCreate && !readOnly">
      <div class="vx-col w-full">
        <vs-button color="primary" style="float:right!important;" type="filled" icon-pack="feather"
          icon="icon-plus-circle" @click="onClickAdd()">Adicionar</vs-button>
      </div>
    </div>
    <div class="vx-row">

    </div>
    <vs-table multiple v-model="selectedRows" :sst="true" @search="handleSearch" @change-page="handleChangePage"
      @sort="handleSort" :max-items="perPage" search noDataText="Nenhum registro encontrado" :data="moduleRows">

      <template slot="thead">
        <template v-for="fieldTitle in tableTitles">
          <template>
            <vs-th :key="fieldTitle.name" :sort-key="fieldTitle.hash">{{ $displayLabel(fieldTitle, 'title') }}</vs-th>
          </template>
        </template>
        <vs-th sort-key="actions">Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <template v-for="(field, key) in data[indextr]">
            <vs-td :key="key" :data="field"
              v-if="key !== '__hash' && key !== '__can_edit' && field !== null && typeof field === 'string' && field.includes('%%')">
              <vx-tooltip color="primary" :text="field.replace('%%', '%')">
                <vs-progress v-if="parseInt(field.replace('%%', '').replace(',', '.')) <= 33" :height="8"
                  :percent="parseInt(field.replace('%%', '').replace(',', '.'))" color="primary"></vs-progress>
                <vs-progress
                  v-else-if="parseInt(field.replace('%%', '').replace(',', '.')) >= 33 && parseInt(field.replace('%%', '').replace(',', '.')) <= 66"
                  :height="8" :percent="parseInt(field.replace('%%', '').replace(',', '.'))"
                  color="primary"></vs-progress>
                <vs-progress v-else :height="8" :percent="parseInt(field.replace('%%', '').replace(',', '.'))"
                  color="primary"></vs-progress>
              </vx-tooltip>
            </vs-td>
            <vs-td :key="key + Math.random().toString()" :data="field"
              v-else-if="field !== null && typeof field === 'object' && field.hasOwnProperty('color') && field.hasOwnProperty('value')">
              <vs-chip :color="field.color" class="product-order-status">{{ $displayLabel(field, 'value') }}</vs-chip>
            </vs-td>
            <vs-td :key="key + Math.random().toString()" :data="field"
              v-else-if="field !== null && typeof field === 'object' && field.hasOwnProperty('value')">
              {{ $displayLabel(field, 'value') }}
            </vs-td>
            <vs-td :key="key + Math.random().toString()" :data="field" v-else-if="key !== '__hash' && key !== '__can_edit'">
              {{ field }}
            </vs-td>
          </template>
          <vs-td>
            <!-- @click="goRelatedModule(relatedTab.moduleHash, data[indextr]['__hash'])" /> -->
            <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer"
              @click="onClickView(data[indextr]['__hash'])" />
            <feather-icon v-show="!readOnly && relatedModulePermissions.canEdit && data[indextr].__can_edit !== false" icon="Edit3Icon"
              svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
              @click="onClickEdit(data[indextr]['__hash'])" />
            <!-- <feather-icon v-show="relatedModulePermissions.canEdit" icon="EditIcon"
              svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
              @click="onClickViewOrEdit('edit', data[indextr]['__hash'])" /> -->
            <feather-icon v-show="!readOnly && relatedModulePermissions.canDelete" icon="Trash2Icon"
              svgClasses="h-5 w-5 mr-2 hover:text-danger cursor-pointer"
              @click="confirmDeleteRecord(data[indextr]['__hash'])" />
            <feather-icon v-show="!readOnly && relatedModulePermissions.canEdit && data[indextr].__can_edit !== false" icon="ExternalLinkIcon"
              svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
              @click="openNewWindow(relatedTab.moduleHash, data[indextr]['__hash'])" />
            <!-- <feather-icon v-show="relatedModuleHasDocumentField" icon="FileTextIcon"
              svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
              @click="openDocument(relatedTab.moduleHash, data[indextr]['__hash'])" /> -->
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <br>
    <vs-pagination :total="pagination.pages" v-model="paginationModel" v-if="pagination.pages > 0"></vs-pagination>
  </div>
</template>

<script>

import { setApplicationLocalStorageItem, performFetch, objectChanges, checkIfStringIsDate, checkIfStringIsDateTime } from '../../helpers'
import QuickCreateModal from './QuickCreateModal.vue'
import { submitFormData, deleteModuleRow } from "../../customFormHelpers"
import StringMask from 'string-mask'

export default {
  components: {
    quickCreateModal: QuickCreateModal,
  },
  computed: {
    allowedFields() {
      return [
        this.$FIELD_TYPES.STRING, this.$FIELD_TYPES.RELATED_TO_A_MODULE, this.$FIELD_TYPES.DOCUMENT, this.$FIELD_TYPES.PERCENTAGE, this.$FIELD_TYPES.DECIMAL, this.$FIELD_TYPES.CURRENCY, this.$FIELD_TYPES.DATE, this.$FIELD_TYPES.DATETIME, this.$FIELD_TYPES.MULTIPLE_DATE,
        this.$FIELD_TYPES.PICKLIST, this.$FIELD_TYPES.INTEGER, this.$FIELD_TYPES.BOOLEAN, this.$FIELD_TYPES.RELATED_TO_A_USER
      ]
    },
    modalComputed: {
      get() {
        return this.openModal;
      },
      set(value) {
        this.openModal = value;
      }
    }
  },
  props: {
    relatedTab: Object,
    rowState: Object,
    delegatorUrl: {
      type: String,
      default: ''
    },
    parentRowHash: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      relatedModulePermissions: {},
      useQuickCreate: true,
      orderData: {},
      perPage: 10,
      selectedRows: [],
      moduleRows: [],
      tableTitles: [],
      searchKey: '',
      fieldDict: {},
      paginationModel: 1,
      pagination: {
        currentPage: 1,
        pages: 1,
        per_page: 10,
        total_records: 0
      },
      openModal: false,
      formData: [],
      disabledFields: [],
      modalAction: 'view',
      modalRowHash: '',
      rowHashToDelete: '',
      modalTitle: '',
      modalTitleData: { module_name: '', module_name_en: '' }
    }
  },
  watch: {
    async paginationModel(newValue, oldValue) {
      // this.resetGetDataInterval()
      if (newValue !== oldValue) {
        // console.log('paginationModel changed', newValue, oldValue)
        // this.$vs.loading({ type: 'default' })
        this.pagination.currentPage = newValue
        // await this.listModuleRows(this.pagination.per_page, newValue)
        // this.$vs.loading.close()
        await this.listModuleRows(this.searchKey, this.pagination.currentPage)
        .then(returnData => {

          const { fieldDict, pagination, relatedModulePermissions, rows, titles } = returnData;

          this.pagination = pagination;
          this.fieldDict = fieldDict;
          this.relatedModulePermissions = JSON.parse(JSON.stringify(relatedModulePermissions));
          this.moduleRows = rows;
          this.tableTitles = titles;
        });
      }
    },
  },
  methods: {
    openNewWindow(moduleHash, rowHash) {
      const newWindowRoute = this.$router.resolve('/modules/edit/' + moduleHash + '/' + rowHash)
      window.open(newWindowRoute.href, '_blank')
    },
    async deleteRow() {
      this.$vs.loading({ type: 'default' });
      await deleteModuleRow(this.relatedTab.moduleHash, this.rowHashToDelete)
        .then(response => {
          // console.log(response);
          this.rowHashToDelete = '';
        })
        .catch(e => {
          console.error(e);
          this.rowHashToDelete = '';
        })

      this.listModuleRows(this.searchKey, this.pagination.currentPage)
        .then(returnData => {

          const { fieldDict, pagination, relatedModulePermissions, rows, titles } = returnData;

          this.pagination = pagination;
          this.fieldDict = fieldDict;
          this.relatedModulePermissions = relatedModulePermissions;
          this.moduleRows = rows;
          this.tableTitles = titles;
        });

      this.onModalClose();

      this.$vs.loading.close();

      this.$vs.notify({
        title: 'Operação realizada',
        text: 'Operação realizada com sucesso!',
        iconPack: 'feather',
        icon: 'icon-check-circle',
        color: 'success'
      })

    },
    confirmDeleteRecord(rowHash) {
      this.rowHashToDelete = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Tem certeza que deseja deletar o registro ?`,
        accept: this.deleteRow,
        acceptText: 'Delete'
      })
    },
    onModalClose() {
      this.openModal = false;
      this.formData = [];
      this.disabledFields = [];
      this.modalAction = 'view';
      this.modalRowHash = '';
      this.modalTitle = '';
      this.modalTitleData = { module_name: '', module_name_en: '' };
    },
    async onModalSave(event) {

      const { data, rowHash } = event;

      try {

        this.$vs.loading({ type: 'default' });

        let response = null;

        if (rowHash) {
          response = await submitFormData('edit', data, this.relatedTab.moduleHash, rowHash);
        } else {
          response = await submitFormData('add', data, this.relatedTab.moduleHash);
        }

        this.listModuleRows(this.searchKey, this.pagination.currentPage)
          .then(returnData => {

            const { fieldDict, pagination, relatedModulePermissions, rows, titles } = returnData;

            this.pagination = pagination;
            this.fieldDict = fieldDict;
            this.relatedModulePermissions = relatedModulePermissions;
            this.moduleRows = rows;
            this.tableTitles = titles;
          });

        this.$vs.notify({
          title: 'Operação realizada',
          text: 'Operação realizada com sucesso!',
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'success'
        })

        if (!rowHash) {
          this.onClickAdd();
        } else {
          this.onModalClose();
        }


        this.$vs.loading.close();
      } catch (e) {
        console.error(e);
        this.$vs.loading.close();
      }
    },
    async onClickAdd() {

      // console.log('useQuickCreate:', this.useQuickCreate)

      if (this.useQuickCreate === false) {
        this.$router.push(`/modules/add/${this.relatedTab.moduleHash}/${this.$route.params.moduleHash}/${this.$route.params.rowHash}/${this.relatedTab.fieldHash}`);
        //TODO
      } else {
        this.$vs.loading({ type: 'default' });

        const relatedModuleHash = this.relatedTab.moduleHash;
        const rowHash = this.$route.params.rowHash;


        this.formData = [];
        this.disabledFields = [];
        this.openModal = true;
        this.modalAction = 'add';
        this.modalTitle = '';
      this.modalTitleData = { module_name: '', module_name_en: '' };

        await performFetch(this.$store.state.auth.api_url, {
          command: 'add_module_row_parameters',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            module_token: relatedModuleHash,
            session_token: this.$store.state.auth.token,
            quick_create: true
          }
        })
          .then(result => {
            if (result.status === 200) {
              result.json().then(response => {
                this.modalTitle = response.detail.module_name;
                this.modalTitleData = { module_name: response.detail.module_name, module_name_en: response.detail.module_name_en };
                for(const block of response.payload.filter(x => x.content_type === 'fields')) {
                  for(const field of block.fields) {
                    // console.log('field', field)
                    // if (this.allowedFields.includes(field.type_id)) {
                      if (field.hash === this.relatedTab.fieldHash) {
                        field['payload'] = rowHash;
                        this.disabledFields.push(field.hash)
                      }

                      this.formData.push({
                        ...field,
                        _block_title: block.title
                      })
                    // }
                  }
                }

                this.formData.sort((a, b) => {
                  if (a.index < b.index) return -1
                  if (a.index < b.index) return 1
                  return 0
                })
              })
            }
          })


        this.$vs.loading.close();
      }
    },
    async onClickView(rowHash) {
      // const newWindowRoute = this.$router.resolve(`/modules/view/${this.relatedTab.moduleHash}/${rowHash}`);
      // window.open(newWindowRoute.href, '_blank')
      // location.href = newWindowRoute.href;

      // this.onClickViewOrEdit('view', rowHash);
      if(this.useQuickCreate) {
        this.onClickViewOrEdit('view', rowHash);
      } else {
        this.$router.push(`/modules/view/${this.relatedTab.moduleHash}/${rowHash}`);
      }
    },
    async onClickEdit(rowHash) {

      if(this.useQuickCreate) {
        this.onClickViewOrEdit('edit', rowHash);
      } else {
        this.$router.push(`/modules/edit/${this.relatedTab.moduleHash}/${rowHash}`);
      }
    },
    async onClickViewOrEdit(action = 'edit', rowHash) {
      // console.log('clicking');
      this.$vs.loading({ type: 'default' });

      this.modalAction = action;
      this.modalRowHash = rowHash;

      const relatedModuleHash = this.relatedTab.moduleHash;
      const parentRowHash = this.$route.params.rowHash;

      this.formData = [];
      this.disabledFields = [];
      this.modalTitle = '';
      this.modalTitleData = { module_name: '', module_name_en: '' };

      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_module_row',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          module_token: relatedModuleHash,
          session_token: this.$store.state.auth.token,
          row_hash: rowHash,
          quick_create: true
        }
      })
        .then(result => {
          if (result.status === 200) {
            result.json().then(response => {
              this.modalTitle = response.detail.module_name;
              this.modalTitleData = { module_name: response.detail.module_name, module_name_en: response.detail.module_name_en };
              for(const block of response.payload.filter(x => x.content_type === 'fields')) {
                for(const field of block.fields) {
                  // if (this.allowedFields.includes(field.type_id)) {

                    if (field.hash === this.relatedTab.fieldHash) {
                      field['payload'] = parentRowHash;
                      this.disabledFields.push(field.hash)
                    }

                    this.formData.push({
                      ...field,
                      _block_title: block.title
                    })
                  // }
                }
              }
              this.formData.sort((a, b) => {
                if (a.index < b.index) return -1
                if (a.index < b.index) return 1
                return 0
              })
              this.openModal = true;
            })
          }
        })


      this.$vs.loading.close();
    },
    handleSearch(searchKey) {
      this.searchKey = searchKey;
      this.listModuleRows(searchKey, this.pagination.currentPage)
        .then(returnData => {

          const { fieldDict, pagination, relatedModulePermissions, rows, titles } = returnData;

          this.pagination = pagination;
          this.fieldDict = fieldDict;
          this.relatedModulePermissions = JSON.parse(JSON.stringify(relatedModulePermissions));
          this.moduleRows = rows;
          this.tableTitles = titles;
        });
    },
    handleChangePage() {

    },
    async listModuleRows(searchKey, currentPage) {
      return new Promise(async (resolve, reject) => {

        let moduleRows = []
        let tableTitles = []
        const fieldDict = {}
        const pagination = {}
        const relatedModulePermissions = {}

        let orderData = null

        if (this.orderData !== null && this.orderData.field !== null && this.orderData.type !== null) {
          orderData = JSON.parse(JSON.stringify(this.orderData))
        }

        const parametersObject = {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          related_module_token: this.relatedTab.moduleHash,
          module_token: this.$route.params.moduleHash,
          related_field_token: this.relatedTab.fieldHash,
          row_hash: this.$route.params.rowHash,
          per_page: this.perPage,
          order: orderData,
          page: currentPage
        }

        if (searchKey !== null) {
          parametersObject['search'] = searchKey
        }

        this.$vs.loading({ type: 'default' })

        await performFetch(this.$store.state.auth.api_url, {
          command: 'list_related_module_rows',
          parameters: parametersObject
        })
          .then((response) => {
            if (response.status === 200) {
              response.json().then((responseData) => {

                this.useQuickCreate = responseData.detail.use_quick_create;

                if (responseData.payload.length > 0) {
                  for (let i = 0; i < Object.keys(responseData.payload[0]['items']).length; i++) {
                    fieldDict[Object.keys(responseData.payload[0]['items'])[i]] = responseData.payload[0]['items'][Object.keys(responseData.payload[0]['items'])[i]]['hash']
                  }
                }

                pagination['currentPage'] = responseData.pagination.current_page
                pagination['pages'] = responseData.pagination.pages
                pagination['total_records'] = responseData.pagination.total_records

                try {
                  relatedModulePermissions['canCreate'] = responseData.permissions.can_create
                  relatedModulePermissions['canEdit'] = responseData.permissions.can_edit
                  relatedModulePermissions['canDelete'] = responseData.permissions.can_delete
                  relatedModulePermissions['canView'] = responseData.permissions.can_view
                  relatedModulePermissions['canList'] = responseData.permissions.can_list
                } catch (e) {
                  console.log('error on assign permissions')
                }

                if (responseData.payload.length > 0) {

                  responseData.payload.sort((a, b) => a.index - b.index)

                  responseData.payload.forEach((item, key) => {

                    let formattedItems = []

                    if (!(item.items && Object.keys(item.items).length === 0 && item.items.constructor === Object)) {

                      for (let i = 0; i < Object.entries(item.items).length; i++) {

                        let itemObject = Object.entries(item.items)[i]

                        const objectKey = itemObject[0]
                        let objectValue = itemObject[1]
                        let objectIndex = objectValue.index

                        if (typeof objectValue === 'object' && objectValue !== null) {

                          if (objectValue.secret === true) {
                            if (tableTitles.find(x => x.name === objectValue.name) === undefined) {
                              tableTitles.push({
                                title: objectValue.title,
                                title_en: objectValue.title_en,
                                name: objectValue.name,
                                index: objectValue.index,
                                hash: objectValue.hash
                              })
                            }

                            objectValue = '*****'
                          } else {
                            if (tableTitles.find(x => x.name === objectValue.name) === undefined) {
                              tableTitles.push({
                                title: objectValue.title,
                                title_en: objectValue.title_en,
                                name: objectValue.name,
                                index: objectValue.index,
                                hash: objectValue.hash
                              })
                            }

                            switch (objectValue.type_id) {

                              case 35:
                                if (Array.isArray(objectValue.payload)) {
                                  let formattedArray = [];
                                  let index = 0;
                                  for (const date of objectValue.payload) {
                                    if (index === 3) {
                                      break;
                                    }
                                    const year = date.split('-')[0]
                                    const month = date.split('-')[1]
                                    const day = date.split('-')[2]
                                    formattedArray.push(`${day}/${month}/${year}`)
                                    index += 1;
                                  }
                                  objectValue = formattedArray.join(", ") + `${objectValue.payload.length > 3 ? "..." : ""}`
                                } else {
                                  objectValue = null;
                                }

                                break;
                              case 16:
                              case 18:
                              case 20:
                                const type_id = objectValue.type_id
                                const showProgressBar = objectValue.show_progress_bar

                                let config = null

                                if (objectValue.type_id === 16 || objectValue.type_id === 20) {
                                  config = { minimumFractionDigits: objectValue.decimals, maximumFractionDigits: objectValue.decimals }
                                } else {
                                  config = { style: 'currency', currency: 'BRL', minimumFractionDigits: objectValue.decimals, maximumFractionDigits: objectValue.decimals }
                                }

                                const value = parseFloat(objectValue.payload)

                                if (!isNaN(value)) {
                                  objectValue = parseFloat(objectValue.payload).toLocaleString('pt-BR', config)

                                  if (type_id === 16) {
                                    if (showProgressBar) {
                                      objectValue = objectValue + '%%'
                                    } else {
                                      objectValue = objectValue + '%'
                                    }
                                  }
                                } else {
                                  objectValue = null
                                }

                                break

                              case 32:
                              case 33:

                              if(objectValue.payload !== null) {
                                // console.log(objectValue)
                                let objectString = ''

                                let itemsAmount = 0

                                for (let item of objectValue.payload_text) {

                                  if (itemsAmount === 5) {
                                    break
                                  }

                                  objectString += item + ', '

                                  itemsAmount += 1
                                }

                                if (objectString !== '') {
                                  objectValue = objectString.substring(0, objectString.length - 2) + ' ...'
                                } else {
                                  objectValue = ''
                                }
                              } else {
                                objectValue = null
                              }

                              break

                              case 19:
                                if (objectValue.payload && objectValue.payload.length > 50) {
                                  objectValue = objectValue.payload.substr(0, 50) + '...'
                                } else {
                                  objectValue = objectValue.payload
                                }

                                break

                              case 12:
                                if (objectValue.payload !== null) {
                                  const isDate = checkIfStringIsDate(objectValue.payload)

                                  if (isDate) {

                                    objectValue = `${objectValue.payload.split('-')[2]}/${objectValue.payload.split('-')[1]}/${objectValue.payload.split('-')[0]}`
                                  }
                                } else {
                                  objectValue = null
                                }

                                break

                              case 13:
                                if (objectValue.payload !== null) {
                                  const isDateTime = checkIfStringIsDateTime(objectValue.payload)

                                  if (isDateTime) {

                                    const date = objectValue.payload.split(' ')[0].trim()
                                    const time = objectValue.payload.split(' ')[1].trim()

                                    objectValue = `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]} ${time}`

                                  }
                                } else {
                                  objectValue = null
                                }

                                break


                              default:

                                if (objectValue.mask) {

                                  if (objectValue.type_id === 3) {

                                    if (objectValue.payload !== null && objectValue.payload.length === 10) {
                                      const formatter = new StringMask('(##) ####-####')
                                      const result = formatter.apply(objectValue.payload)

                                      objectValue = result
                                    } else if (objectValue.payload !== null && objectValue.payload.length === 11) {
                                      const formatter = new StringMask('(##) #####-####')
                                      const result = formatter.apply(objectValue.payload)

                                      objectValue = result
                                    } else {
                                      const formatter = new StringMask(objectValue.mask)
                                      const result = formatter.apply(objectValue.payload)

                                      objectValue = result
                                    }
                                  } else {

                                    if (!objectValue.save_mask) {
                                      try {

                                        let formatter = null;

                                        if (typeof objectValue.mask === 'object' && objectValue.mask.length === 1) {
                                          formatter = new StringMask(objectValue.mask[0])
                                        } else {
                                          formatter = new StringMask(objectValue.mask[0])
                                        }

                                        const result = formatter.apply(objectValue.payload)

                                        objectValue = result
                                      } catch (e) {
                                        objectValue = objectValue.payload
                                      }
                                    } else {
                                      objectValue = objectValue.payload
                                    }
                                  }

                                } else {
                                  objectValue = objectValue.payload
                                }

                                break

                            }

                          }

                          itemObject[1] = objectValue
                        }

                        const fieldObject = {
                          key: itemObject[0],
                          value: itemObject[1],
                          index: objectIndex
                        }

                        formattedItems.push(fieldObject)
                      }

                      tableTitles = tableTitles.sort((a, b) => a.index - b.index)
                      formattedItems = formattedItems.sort((a, b) => a.index - b.index)

                      formattedItems.push({ key: '__hash', value: item.identification })
                      formattedItems.push({ key: '__can_edit', value: item.can_edit !== undefined ? item.can_edit : true })

                      const moduleRow = {}

                      for (let i = 0; i < formattedItems.length; i++) {
                        moduleRow[formattedItems[i]['key']] = formattedItems[i]['value']
                      }

                      moduleRows[key] = moduleRow
                    } else {
                      moduleRows = []
                    }
                  })
                }

                this.$vs.loading.close()

                // let moduleRows = []
                // let tableTitles = []
                // const fieldDict = {}
                // const pagination = {}
                // const relatedModulePermissions = {}

                this.$emit("onChange", {
                  "event": "table_loaded",
                  "tabData": this.relatedTab,
                  data: responseData.payload
                })

                resolve({ rows: moduleRows, titles: tableTitles, fieldDict: fieldDict, pagination: pagination, relatedModulePermissions: relatedModulePermissions })
              })
                .catch(e => {
                  console.log(e)
                  this.$vs.loading.close()
                  this.$vs.notify({
                    title: 'Atenção!',
                    text: e.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                  reject(e.message)
                  throw new Error(e.message)
                })
            } else if (response.status === 400) {
              this.$vs.loading.close()
              this.moduleRows = []
              reject(false)
            } else if (response.status === 403) {
              this.$vs.loading.close()
              this.showEmptyDataMessage = true
              reject(false)
            } else if (response.status === 401) {
              setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
              this.$store.dispatch('auth/signOut')
              reject(false)
            } else {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação não realizada!',
                text: 'Ocorreu um erro ao listar os registros do módulo',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              reject(false)
            }
          })
          .catch((e) => {
            console.log(e)
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção!',
              text: e.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            reject(e.message)
          })
      })
    },
    async handleSort(key, active) {
      // console.log('handleSort', key, active)
      if (active !== null) {
        this.orderData.field = key
        this.orderData.type = active.toUpperCase()
      }


      console.log('handleSort', key, active)
      console.log('orderData', this.orderData)

      // await this.getModuleParameters(this.relatedTab.moduleHash)
      // await this.listModuleRows(this.relatedTab)
      await this.listModuleRows(this.searchKey, this.pagination.currentPage)
      .then(returnData => {

        const { fieldDict, pagination, relatedModulePermissions, rows, titles } = returnData;

        this.pagination = pagination;
        this.fieldDict = fieldDict;
        this.relatedModulePermissions = JSON.parse(JSON.stringify(relatedModulePermissions));
        this.moduleRows = rows;
        this.tableTitles = titles;
      });
    },
  },
  async mounted() {
    console.log('here - related module table mounted', JSON.stringify(this.relatedTab))
    await this.listModuleRows(this.searchKey, this.pagination.currentPage)
    .then(returnData => {

      const { fieldDict, pagination, relatedModulePermissions, rows, titles } = returnData;

      this.pagination = pagination;
      this.fieldDict = fieldDict;
      this.relatedModulePermissions = JSON.parse(JSON.stringify(relatedModulePermissions));
      this.moduleRows = rows;
      this.tableTitles = titles;
    });
  },
}

</script>
